import {ImageItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-image-options/poster-editing-image-options.types';
import {useEffect} from 'react';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';
import {ShadowOrGlowType} from '@postermywall/fabricjs-2';

export function useIsOpenedImagePanelValid(currentlyOpenedColorPanel: ImageItemPanels, setCurrentlyOpenedColorPanel: (newVal: ImageItemPanels) => void): void {
  const shadowOrGlowType = useGetKeyFromShadowOfActiveItem('shadowOrGlowType');
  const solidBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const tint = useGetKeyFromEffectsActiveItem('tint');
  const removeColor = useGetKeyFromEffectsActiveItem('removeColor');
  const multiply = useGetKeyFromEffectsActiveItem('multiply');

  useEffect((): void => {
    if (shadowOrGlowType !== ShadowOrGlowType.CUSTOM_SHADOW && currentlyOpenedColorPanel === ImageItemPanels.SHADOW) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [shadowOrGlowType]);

  useEffect((): void => {
    if (!(shadowOrGlowType === ShadowOrGlowType.LIGHT_GLOW || shadowOrGlowType === ShadowOrGlowType.STRONG_GLOW) && currentlyOpenedColorPanel === ImageItemPanels.GLOW) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [shadowOrGlowType]);

  useEffect((): void => {
    if (solidBorderType === BorderType.NONE && currentlyOpenedColorPanel === ImageItemPanels.BORDER) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [solidBorderType]);

  useEffect((): void => {
    if (!tint && currentlyOpenedColorPanel === ImageItemPanels.TINT) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [tint]);

  useEffect((): void => {
    if (!removeColor && currentlyOpenedColorPanel === ImageItemPanels.REMOVE_COLOR) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [removeColor]);

  useEffect((): void => {
    if (!multiply && currentlyOpenedColorPanel === ImageItemPanels.MULTIPLY) {
      setCurrentlyOpenedColorPanel(ImageItemPanels.NONE);
    }
  }, [multiply]);

  return;
}
